export default {
  en: {
    Common: {
      reset: 'Reset',
      close: 'Close',
      back: 'Back'
    },
    Auth: {
      signUp: 'Sign up',
      activation: 'Activation',
      signIn: 'Sign in',
      signOut: 'Sign Out',
      passwordReset: 'Password reset',
      passwordInitialize: 'Password Initialize',
      passwordUpdate: 'Password Update',
      userId: 'User ID',
      email: 'E-mail',
      password: 'Password',
      reenterPassword: 'Re-enter password:',
      verificationCode: 'Verification code',
      sendVerificationCode: 'Send verification code',
      forgotPassword: 'Forgot password ?',
      sendPasswordResetMail: 'Send Password Reset Mail',
      newpassword: 'New password',
      reenterNewPassword: 'Re-enter New Password:',
      updatePassword: 'Update Password',
      currentPassword: 'Current Password'
    }
  }
}
